export enum TournamentStage {
    SINGLE = 'SINGLE',
    PLAYOFFS = 'PLAYOFF',
    GROUPS = 'GROUPS',
    GROUPS_AND_PLAYOFFS = 'GROUPS_AND_PLAYOFFS',
}
